const features = [
  {
    icon: 'ri-line-chart-line',
    title: 'Real Market Value',
    description:
      'We use live market data — not a dusty book from 2018 — so your offer reflects what your car is actually worth today.',
  },
  {
    icon: 'ri-chat-off-line',
    title: 'No Negotiation Theater',
    description:
      'We give you a real number upfront. No "let me run this by my manager" back-and-forth. Just a straight answer.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Any Condition, No Drama',
    description:
      'High miles, a dent, a weird smell — we\'ve seen it all. We\'ll still make you an offer. No judgment, no lowball because of a scratch.',
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Your Call, Your Money',
    description:
      'Roll it into your next purchase or take the cash. Either way, it\'s your decision — not ours.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Fast. Like, Actually Fast.',
    description:
      'Most appraisals come back within 24 hours. Some same-day. Because your time is worth something too.',
  },
  {
    icon: 'ri-thumb-up-line',
    title: 'Zero Obligation',
    description:
      'Get your number, shop it around, compare it. We\'re confident in our offers — we don\'t need to pressure you into anything.',
  },
];

export default function TradeInWhyUs() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            Why Trade In With Us?
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Because "we'll give you whatever we feel like" isn't a trade-in policy. Ours actually is.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#F7F5F0] rounded-2xl p-8 border-2 border-[#E8E2D6] hover:border-[#E8B84B] transition-all group"
            >
              <div className="w-16 h-16 bg-[#E8B84B] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-[#1C2B1E]`}></i>
              </div>
              <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
